import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/new-js-file.svg
 */
const IconNewJsFile: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M18.473 11.28H2.662a.723.723 0 00-.72.72v7.186a.723.723 0 00.72.72h15.81a.72.72 0 00.718-.72v-7.187a.718.718 0 00-.717-.72zm-8.505 5.108a1.275 1.275 0 01-1.424 1.448 1.442 1.442 0 01-1.254-.593c-.293-.35.258-.855.556-.487a.852.852 0 00.752.353c.324 0 .604-.154.61-.72v-2.271a.382.382 0 01.38-.353.38.38 0 01.38.353v2.27zm.967 1.074a.437.437 0 01-.081-.564.34.34 0 01.39-.118.341.341 0 01.122.078c.47.322 1.684.564 1.77-.254-.075-.85-2.466-.339-2.287-1.968.132-1.114 1.814-1.312 2.608-.704a.336.336 0 01-.243.621.337.337 0 01-.125-.06c-.437-.27-1.39-.398-1.511.2-.155.944 2.345.405 2.303 1.932-.037 1.459-2.152 1.49-2.946.837z"
      fill="currentColor"
    />
    <path
      d="M21.348 5.952l-4.735-4.734A2.695 2.695 0 0014.88.5H6.964a2.159 2.159 0 00-2.157 2.154v7.189a.719.719 0 101.438 0V2.654a.72.72 0 01.72-.717h6.468a1.439 1.439 0 011.437 1.437V6.07a1.621 1.621 0 001.616 1.617h2.696a1.44 1.44 0 011.44 1.437v12.22a.72.72 0 01-.72.717H6.963a.72.72 0 01-.72-.718.717.717 0 00-1.226-.507.717.717 0 00-.21.507A2.162 2.162 0 006.963 23.5h12.937a2.163 2.163 0 002.157-2.158V7.686a2.684 2.684 0 00-.71-1.734z"
      fill="currentColor"
    />
  </svg>
);

export default IconNewJsFile;
